export default {
  accordionItem: {
    base: {
      borderColor: 'grey-30',
      bg: 'white',
      mt: 0
    }
  },
  accordionButton: {
    base: {
      'h3&': {
        mt: 0
      },
      hover: {
        bg: 'grey-05',
        textDecoration: 'none'
      },
      focus: {
        bg: 'primary-yellow-100',
        outline: 'none'
      }
    }
  }
};